import { tss } from "tss-react/mui";

export const useCartSectionStyles = tss.withName("CartSection").create(({ theme }) => ({
    root: {
        padding: "56px 4% 96px",
    },
    container: {
        maxWidth: "1000px",
        margin: "0 auto",
    },
    title: {
        marginBottom: theme.spacing(4),
    },
    empty: {
        textAlign: "center" as const,
        padding: theme.spacing(8, 0),
        color: theme.palette.text.secondary,
    },
    lines: {
        display: "flex",
        flexDirection: "column" as const,
        gap: theme.spacing(3),
        marginBottom: theme.spacing(4),
    },
    line: {
        display: "grid",
        gridTemplateColumns: "88px 1fr auto auto",
        gap: theme.spacing(2.5),
        alignItems: "center",
        paddingBottom: theme.spacing(3),
        borderBottom: `1px solid ${theme.palette.divider}`,
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "64px 1fr",
            rowGap: theme.spacing(1.5),
        },
    },
    imageWrapper: {
        width: 88,
        height: 88,
        overflow: "hidden",
        backgroundColor: theme.palette.primary[50],
        [theme.breakpoints.down("sm")]: {
            width: 64,
            height: 64,
        },
    },
    image: {
        width: "100%",
        height: "100%",
        objectFit: "cover" as const,
    },
    productTitle: {
        fontWeight: 600,
        textDecoration: "none",
        color: "inherit",
    },
    variantTitle: {
        color: theme.palette.text.secondary,
        fontSize: "0.85rem",
    },
    quantityControl: {
        display: "flex",
        alignItems: "center",
        border: `1px solid ${theme.palette.divider}`,
        width: "fit-content",
    },
    quantityButton: {
        minWidth: 32,
        borderRadius: 0,
    },
    quantityValue: {
        minWidth: 28,
        textAlign: "center" as const,
        fontFamily: "'Fira Code', monospace",
        fontWeight: 500,
    },
    lineEnd: {
        display: "flex",
        flexDirection: "column" as const,
        alignItems: "flex-end",
        gap: theme.spacing(1),
    },
    lineTotal: {
        fontFamily: "'Fira Code', monospace",
        fontWeight: 500,
    },
    removeButton: {
        fontSize: "0.75rem",
        color: theme.palette.text.secondary,
        textTransform: "none" as const,
        padding: 0,
        minWidth: 0,
    },
    summary: {
        borderTop: `1px solid ${theme.palette.divider}`,
        paddingTop: theme.spacing(3),
    },
    summaryRow: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: theme.spacing(1),
    },
    subtotalValue: {
        fontFamily: "'Fira Code', monospace",
        fontWeight: 500,
    },
    shippingNote: {
        color: theme.palette.text.secondary,
        fontSize: "0.8rem",
        marginBottom: theme.spacing(3),
    },
    checkoutActions: {
        display: "flex",
        flexDirection: "column" as const,
        gap: theme.spacing(1.5),
        alignItems: "flex-end",
        [theme.breakpoints.down("sm")]: {
            alignItems: "stretch",
        },
    },
    redirectNote: {
        color: theme.palette.text.disabled,
        fontSize: "0.75rem",
    },
}));
